import React from 'react';
import { FiCheck } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const SpecPanel = () => {
  const specs = [
    { label: "Waterproofing", value: "28,000mm HH" },
    { label: "Breathability", value: "RET < 6" },
    { label: "Weight", value: "410g (Size M)" },
    { label: "Material", value: "3-Layer GORE-TEX® PRO" },
  ];

  return (
    <section className="py-20 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative aspect-square lg:aspect-[4/5] border border-zinc-800 p-4">
            <div className="absolute top-8 left-8 z-10 bg-orange-600 px-3 py-1 font-black uppercase text-sm tracking-widest border border-orange-400">
              Flagship Model
            </div>
            <img 
              src="https://images.unsplash.com/photo-1605050825077-289f85b6cf43?auto=format&fit=crop&w=1000&q=80" 
              alt="Jacket Details" 
              className="w-full h-full object-cover filter grayscale hover:grayscale-0 transition-all duration-700"
            />
            {/* Technical Target Overlay */}
            <div className="absolute top-1/3 right-1/4 w-4 h-4 border-2 border-orange-500 rounded-full flex items-center justify-center animate-pulse">
              <div className="w-1 h-1 bg-orange-500 rounded-full" />
              <div className="absolute left-full ml-4 w-48 bg-zinc-900/90 border border-zinc-800 p-3 text-xs uppercase tracking-wider hidden md:block">
                <span className="text-orange-500 font-bold block mb-1">Area 01</span>
                Reinforced Kevlar Stitching
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-4xl font-black uppercase tracking-tighter mb-4">
              Engineered for the <br /><span className="text-orange-500">Extremes</span>
            </h2>
            <p className="text-zinc-400 mb-8 text-lg leading-relaxed">
              The Apex Hardshell represents the pinnacle of alpine protection. 
              Stripped of unnecessary features, leaving only what guarantees survival.
            </p>

            <div className="space-y-6 mb-10">
              {specs.map((spec, idx) => (
                <div key={idx} className="border-b border-zinc-800 pb-4">
                  <div className="flex justify-between items-end mb-2">
                    <span className="text-sm font-bold uppercase tracking-widest text-zinc-500">{spec.label}</span>
                    <span className="text-lg font-black">{spec.value}</span>
                  </div>
                  {/* Progress bar visual for specs */}
                  <div className="w-full h-1 bg-zinc-900">
                    <div className="h-full bg-orange-600" style={{ width: `${80 + (idx * 5)}%` }} />
                  </div>
                </div>
              ))}
            </div>

            <ul className="space-y-3 mb-10">
              {['YKK® AquaGuard® VISLON® front zip', 'Helmet-compatible StormHood™', 'Cohaesive™ hem adjusters'].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-zinc-300">
                  <SafeIcon icon={FiCheck} className="text-orange-500 shrink-0" />
                  <span className="uppercase tracking-wide text-sm font-bold">{item}</span>
                </li>
              ))}
            </ul>

            <button className="w-full bg-orange-600 hover:bg-orange-500 text-white font-black uppercase tracking-widest py-5 border border-orange-400 transition-colors">
              Add to Loadout - $499
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecPanel;